import * as SelectPrimitive from '@radix-ui/react-select';
const SelectValue = SelectPrimitive.SelectValue;
export default SelectValue;
